<template>
  <div class="about-wm">
    <pageHeader title="关于万梦" />

    <div class="container">
      <div class="wm-logo">
        <img src="@/assets/images/wm-logo.png" alt="" />
        <span>万梦手游</span>
        <span>v2.0.0</span>
      </div>

      <div class="about-cell">
        <div
          class="cell-item"
          :style="{ marginBottom: item.mgBottom }"
          v-for="item in cellList"
          :key="item.key"
          @click="doOperate(item)"
        >
          <div class="cell-item-container">
            <img class="cell-icon" :src="item.icon" alt="" />
            <span class="cell-span">{{ item.label }}</span>
          </div>
          <img class="arrow" src="@/assets/images/arrow.png" alt="" />
        </div>
      </div>
    </div>

    <van-dialog
      v-model="showDialog"
      title="请输入兑换码"
      show-cancel-button
      width="280px"
      confirm-button-color="#666666"
      cancel-button-color="#BBBBBB"
      @confirm="codeEvent"
    >
      <div class="code-input">
        <van-field v-model="redemptionCode" size="small"></van-field>
      </div>
    </van-dialog>

    <!-- 优惠券 -->
    <couponDialog 
      v-if="couponDialogVisible"
      v-model="couponDialogVisible"
      :couponInfo="couponInfo"
    />
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import couponDialog from "@/components/CouponDialog"
import { Dialog } from 'vant'
import { requestMethods } from "@m/api";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    pageHeader,
    couponDialog
  },
  computed: {
    ...mapGetters(["uuid", "userInfo"]),
  },
  data() {
    return {
      cellList: [
        {
          icon: require("@/assets/images/about-cell2.png"),
          label: "隐私协议",
          key: "privacyAgreement"
        },
        {
          icon: require("@/assets/images/about-cell3.png"),
          label: "服务协议",
          key: "serviceAgreement"
        },
        {
          icon: require("@/assets/images/about-cell3.png"),
          label: "建议反馈",
          mgBottom: "10px",
          key: "leaveMsg"
        },
        {
          icon: require("@/assets/images/about-cell4.png"),
          label: "兑换优惠券",
          mgBottom: "10px",
          key: "coupon",
        }
      ],
      redemptionCode: "",
      showDialog: false,
      couponInfo: {},
      couponDialogVisible: false
    };
  },
  created() {
    if(this.uuid) {
      this.cellList.push(
        {
          icon: require("@/assets/images/about-cell5.png"),
          label: "退出登录",
          key: "loginout",
        }
      )
    }
  },
  methods: {
    ...mapActions(["cleanUuid", "cleanUserInfo"]),

    doOperate(scope) {
      switch (scope.key) {
        case "coupon":
          this.showDialog = true;
          break;
        case "loginout":
          Dialog.confirm({
            title: "温馨提示",
            message: "您确定退出登录吗？",
            confirmButtonColor: "#FF7A3E",
            width: "280px"
          }).then(() => {
            // on confirm
            this.cleanUuid()
            this.cleanUserInfo()
            this.$router.replace('/login')
          });
          break;
          case "privacyAgreement":
            this.$router.push({ path: '/privacyAgreement' })
            break
          case "serviceAgreement":
            this.$router.push({ path: '/serviceAgreement' })
            break
          case "leaveMsg":
            this.$router.push({ path: '/leaveMsg' })
            break
            
      }
    },
    /**
     * 兑换优惠券
     */
    async codeEvent() {
      try {
        const { data } = await requestMethods(
          "/modules/coupon/userCoupon/fetchCouponByExchangeCode.htm",
          "post",
          {
            uuid: this.uuid,
            exchangeCode: this.redemptionCode,
            appType: 'WM'
          }
        );
        this.$toast({
          message: '兑换成功！',
          position: "bottom",
        });
        this.couponDialogVisible = true
        this.couponInfo = {
          ...data
        }
        this.showDialog = false;
        this.redemptionCode = ''
      } catch (error) {
        this.$toast({
          message: error.message,
          position: "bottom",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.about-wm {
  min-height: 100vh;
  background: #f8f8f8;

  .container {
    .wm-logo {
      text-align: center;
      margin: 60px 0;
      img {
        width: 150px;
        height: 150px;
      }
      span {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 30px;
        color: #212121;
        line-height: 42px;
        display: block;

        &:last-child {
          font-weight: 400;
          font-size: 26px;
          color: #bbbbbb;
          line-height: 37px;
        }
      }
    }

    .about-cell {
      .cell-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 20px;
        background: #fff;
        height: 100px;
        padding: 0 40px;

        .cell-item-container {
          display: flex;
          align-items: center;

          .cell-icon {
            width: 40px;
            height: 40px;
            margin-right: 20px;
          }
          .cell-span {
            font-weight: 400;
            font-size: 28px;
            color: #212121;
          }
        }
        .arrow {
          width: 22px;
          height: 36px;
        }
      }
    }
  }

  .code-input {
    padding: 40px 80px;
    margin: 0 auto;

    .van-cell {
      width: 400px;
      // height: 70px;
      background: #fafafa;
      border: 2px solid #dfdfdf;
      padding: 10px 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/aboutWM/index.vue